import { FormClassRetire } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const steps = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構への提出確認",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "text",
    showLine: false,
  },
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    type: "text",
  },
  {
    title: "請求者氏名（全角漢字）",
    keyword: "demanderName",
    type: "text",
  },
  {
    title: "請求者生年月日",
    keyword: "demanderBirth",
    type: "text",
  },
  {
    title: "請求者住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "text",
  },
  {
    title: "請求者住所",
    keyword: "locationGroup",
    type: "text",
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "text",
  },
  {
    title: "請求者メールアドレス",
    keyword: "demanderEmail",
    type: "text",
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
  },
  {
    title: "金融機関名",
    keyword: "bankName",
    type: "text",
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "text",
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    type: "text",
  },
  {
    title: "口座名義人名(半角ｶﾀｶﾅ)",
    keyword: "accountNameKana",
    type: "text",
  },
  {
    title: "①「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathOrAutopsyReport",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["「死亡診断書」又は「死体検案書」（写）"],
  },
  {
    title:
      "②職員の死亡当時、主として職員の収入により生計を維持していた親族が{$1}ことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "livelihoodInvestForm",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "④内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "marriageReport",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "⑤職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certifiedCertificateResidence",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["職員の死亡当時の住民票の謄本"],
  },
  {
    title: "⑥その他、事実上の配偶者であることを証明する書類",
    keyword: "documentCertifyingSpouse",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["事実上の配偶者であることを証明する書類"],
  },
  {
    title: "確認する書類の選択",
    keyword: "identificationDocsKind",
    type: "text",
    showLine: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs1",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["本人確認書類"],
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs2",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["本人確認書類"],
  },
  {
    title: "本人であることを確認するための書類（表面）",
    keyword: "identityHead",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["本人確認書類（表面）"],
  },
  {
    title: "本人であることを確認するための書類（裏面）",
    keyword: "identityTail",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["本人確認書類（裏面）"],
  },
  {
    title: "死亡した退職者の個人番号を確認する書類",
    keyword: "deceasedRetireeNumCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["死亡した退職者の個人番号を確認する書類"],
  },
  {
    title: "個人番号を確認する書類",
    keyword: "numberCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["個人番号を確認する書類"],
  },
  {
    title: "振込先口座が確認できる書類",
    keyword: "payAccountCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: FormClassRetire["振込先口座が確認できる書類"],
  },
];

export { steps, fakeTableList };
